import { render, staticRenderFns } from "./ModalContentDocumentDelete.vue?vue&type=template&id=8283e054&scoped=true&"
import script from "./ModalContentDocumentDelete.vue?vue&type=script&lang=js&"
export * from "./ModalContentDocumentDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentDocumentDelete.vue?vue&type=style&index=0&id=8283e054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8283e054",
  null
  
)

export default component.exports